__turbopack_context__.v({
  "filterRow": "MobileFilterMenuRow-module-scss-module__juTBwa__filterRow",
});
